module.exports = {
  marginLarge: "32px",
  gutterLarge: "16px",
  marginSmall: "24px",
  gutterSmall: "12px",
};